import List from './List';
import reducer from './reducer';

const Notifications = {
  List,
  reducer
};

export default Notifications;
